import { render } from "./UploadStatusContainer.vue?vue&type=template&id=37c20b7c&scoped=true"
import script from "./UploadStatusContainer.vue?vue&type=script&lang=js"
export * from "./UploadStatusContainer.vue?vue&type=script&lang=js"

import "./UploadStatusContainer.vue?vue&type=style&index=0&id=37c20b7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c20b7c"]])

export default __exports__